import classNames from "classnames";
import { FC } from "react";
import styles from "./styles.module.css";

type ProfileImageProps = {
  imgSrc: string;
  imageStyle?: string | string[];
};

const ProfileImageSmall: FC<ProfileImageProps> = ({ imgSrc, imageStyle }) => {
  return (
    <div
      className={classNames({ "bg-cover": !imageStyle }, [
        "relative",
        "bg-no-repeat",
        "aspect-w-16",
        "aspect-h-9",
        styles["image"],
        imageStyle,
      ])}
      style={{
        backgroundImage: `url(${imgSrc})`,
      }}
    ></div>
  );
};

export default ProfileImageSmall;
